import { lazy } from 'react'
import { DASHBOARDS } from './registry'

/**
 * Módulo: Mercado Libre
 * Dashboards, integraciones y métricas de ML.
 */
export default {
  id: 'mercadolibre',
  nombre: 'Mercado Libre',
  descripcion: 'Dashboards, métricas y herramientas para sellers de Mercado Libre',
  icono: 'shopping-cart',
  tipo: 'marketplace',
  version: '1.0.0',
  // ML es visible para admin, consultor y también para el seller (su empresa)

  routes: [
    // Protocolo Bombai Fase 2b — receptor del redirect post-OAuth.
    // Plataforma-agnóstica: se usa para ML, Google, Amazon, TN, Shopify, etc.
    { path: 'conexion-resultado', component: lazy(() => import('./pages/ConexionResultadoPage')), public: true },
    // Protocolo Bombai Fase 2c — self-service link multi-cuenta.
    // El consultor genera un link desde Integraciones y el cliente abre acá
    // SIN loguearse en Bombai. Bloque 0.3 sub-paso f (mayo 2026): reemplaza
    // al legacy /conectar-ml/:token (eliminado).
    { path: 'conectar/:token', component: lazy(() => import('./pages/ConectarCuentaPublicoPage')), public: true },
  ],

  // Los dashboards ML se muestran dentro de EmpresaDetailPage, no como páginas standalone
  menuItems: [],

  // Declaración que junta el agregador neutro (`core/lib/dashboardsRegistro`,
  // ADR 2026-08-16 decisión 1). Misma constante que deriva `vistasEmpresa` —
  // una fuente, dos proyecciones.
  dashboards: DASHBOARDS,

  // Vistas gateables que aporta este módulo al árbol de "Vista detallada de
  // empresa": cada CARD de dashboard (bajo el grupo 'dashboards'). Deriva del
  // registro DASHBOARDS — fuente única, sin duplicar ids/nombres.
  vistasEmpresa: DASHBOARDS.map(d => ({
    id: d.id,
    label: d.nombre,
    grupo: 'dashboards',
    grupoLabel: 'Dashboards',
    grupoOrden: 5,
    orden: d.orden ?? 99,
  })),

  features: [
    'dashboards-ml',
    'integracion-oauth-ml',
    'sync-items',
    'sync-ventas',
    'flex-config',
  ],

  // permisoModulos (#58): se deriva del rol. menuItems está vacío (los dashboards
  // ML viven dentro de EmpresaDetailPage) → no genera grupo propio en el sidebar.
  permisoModulos: ['mercadolibre'],

}
